import React, { useState } from 'react';
import axios from 'axios';

const ROLL_NO_REGEX = /^[A-Z]{2}\d{2}-[A-Z]{2,5}-\d{3}$/;
const PHONE_REGEX = /^\d{10,15}$/;

const StudentForm = ({ onStudentAdded, initialData = null }) => {
  const [formData, setFormData] = useState(
    initialData || {
      name: '',
      roll_no: '',
      class: '',
      phone: ''
    }
  );
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'roll_no' ? value.toUpperCase() : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const payload = {
      ...formData,
      roll_no: formData.roll_no.replaceAll(/\s+/g, '').toUpperCase(),
      phone: formData.phone.replaceAll(/\s+/g, ''),
      name: formData.name.trim(),
      class: formData.class.trim()
    };

    if (!ROLL_NO_REGEX.test(payload.roll_no)) {
      setError('Invalid roll number format. Use format like FA23-BSE-129.');
      return;
    }

    if (!PHONE_REGEX.test(payload.phone)) {
      setError('Phone number must be 10 to 15 digits only.');
      return;
    }

    setLoading(true);

    try {
      if (initialData && initialData.id) {
        await axios.put(`/api/students/${initialData.id}`, payload);
      } else {
        await axios.post('/api/students', payload);
      }
      setFormData({
        name: '',
        roll_no: '',
        class: '',
        phone: ''
      });
      if (onStudentAdded) {
        onStudentAdded();
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error adding student');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <h2>{initialData ? 'Update Student' : 'Add New Student'}</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name *</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Enter student name"
          />
        </div>

        <div className="form-group">
          <label>Roll Number *</label>
          <input
            type="text"
            name="roll_no"
            value={formData.roll_no}
            onChange={handleChange}
            required
            pattern="[A-Z]{2}[0-9]{2}-[A-Z]{2,5}-[0-9]{3}"
            title="Use format like FA23-BSE-129"
            placeholder="e.g. FA23-BSE-129"
          />
        </div>

        <div className="form-group">
          <label>Class *</label>
          <input
            type="text"
            name="class"
            value={formData.class}
            onChange={handleChange}
            required
            placeholder="Enter class"
          />
        </div>

        <div className="form-group">
          <label>Phone Number *</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            pattern="\d{10,15}"
            title="Phone number must be 10 to 15 digits"
            placeholder="Enter phone number"
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving...' : initialData ? 'Update Student' : 'Add Student'}
        </button>
      </form>
    </div>
  );
};

export default StudentForm;
